/**
 * Defines a collection view of buttons specific to reporting filters
 */

import Radio from "backbone.radio";
import ButtonCollectionView from "../../../views/generic/button/collection";
import ButtonView from "./dropdown";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

const DEFAULTS = {
  tagName: "form",
  className: "btn-group",
  childView: ButtonView,
};

class View extends ButtonCollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  attributes() {
    return {
      action: "#apply-filters",
    };
  }

  ui() {
    return {
      options: ".options-wrapper",
      kendoWidgets: ".k-widget",
      resetBtn: "button.reset",
    };
  }

  events() {
    return {
      "click @ui.options": "_onOptionsClick",
      "click @ui.kendoWidgets": "_onOptionsClick",
      "click @ui.resetBtn": "_onReset",
      submit: "_onSubmit",
    };
  }

  _onOptionsClick(e) {
    e.stopPropagation();
  }

  _onSubmit(e) {
    e.preventDefault();

    // extract submitted form data and announce it
    let formData = {};
    try {
      formData = Backbone.Syphon.serialize(this);
    } catch (err) {
      console.error(err.stack);
    }

    /**
     * Special handling for group-by checkboxes.
     *
     * This behavior was discussed on 27-Jun-2016 and it was deemed to be
     * working as expected by Deb and Tracey despite it not passing a blank
     * param when all options are unchecked. We will revisit this issue
     * again for release 16.1.0.
     */
    /**
     * 12-Feb-2019
     * Selector was updated to be specific to the group by checkboxes.
     * This will continue to work as long as the input name remains groupByKey
     */
    const $groupBy = this.$("input[name=groupByKey]:checked");
    if ($groupBy.length) {
      const values = $groupBy.get().map((input) => input.value);
      formData[$groupBy[0].name] = values;
    }

    // announce updated filter selections
    reportChannel.trigger(this.options.updatedFilterEventName, formData);
  }

  _onReset() {
    // retrieve current route
    const state = globalChannel.request("router:getState");
    const data = state && state.has("nav") ? state.getNav().originalData : {};

    // announce report filters were reset
    // reportChannel.request("report-filters-reset", state.toJSON());

    // announce empty filter selections
    reportChannel.trigger(this.options.updatedFilterEventName, data);
  }
}

export { View as default };
